export enum BackendRoute {
  AUTH_REFRESH = '/auth/refresh',
  COMPANIES = '/companies',
  COUNTRIES = '/countries',
  IMAGE_UPLOAD = '/upload/image',
  LOGIN = '/login',
  NOTIFICATIONS = '/notifications',
  PERKS = '/perks',
  PLANS = '/plans',
  STAKEHOLDERS = '/stakeholders',
  SUBSCRIPTION_OFFERS = '/subscription-offers',
  TEAM_MEMBERS = '/team/members',
  TEAM_PUBLIC_HOLIDAYS = '/team/public-holidays',
  TEAM_VACATIONS = '/team/vacations',
  VALIDATE = '/validate',
}
